<template>
  <layout>
    <div slot="content">
      <i-card title="合同模板管理">
        <div slot="content">
          <div class="toolbar">
            <el-input
              v-model="keyword"
              placeholder="搜索模板名称"
              size="small"
              style="width: 220px; margin-right: 10px"
              clearable
              @keyup.enter.native="loadList"
            />
            <el-button size="small" type="primary" @click="loadList">搜索</el-button>
            <el-button size="small" type="success" @click="goAdd">+ 新增模板</el-button>
          </div>

          <el-table :data="list" v-loading="loading" border style="width: 100%; margin-top: 15px">
            <el-table-column prop="id" label="ID" width="70" />
            <el-table-column prop="name" label="模板名称" min-width="200" />
            <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip />
            <el-table-column label="状态" width="90">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="small">
                  {{ scope.row.status === 1 ? '启用' : '禁用' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="created_at" label="创建时间" width="170" />
            <el-table-column label="操作" width="200" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" @click="goEdit(scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="handleDel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-wrap">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="pageSize"
              :current-page="currentPage"
              @current-change="onPageChange"
            />
          </div>
        </div>
      </i-card>
    </div>
  </layout>
</template>

<script>
import layout from '@/components/layout'
import iCard from '@/components/i-card'

export default {
  name: 'contract-list',
  components: { layout, iCard },
  data() {
    return {
      loading: false,
      list: [],
      keyword: '',
      total: 0,
      pageSize: 15,
      currentPage: 1,
    }
  },
  methods: {
    loadList() {
      this.loading = true
      this.$http.request('contractTemplateList', {
        keyword: this.keyword,
        page: this.currentPage,
      }).then(res => {
        this.loading = false
        if (res && res.data) {
          this.list = res.data.data || []
          this.total = res.data.total || 0
          this.pageSize = res.data.per_page || 15
        }
      }).catch(() => {
        this.loading = false
      })
    },
    goAdd() {
      this.$router.push({ name: 'contract.template_form' })
    },
    goEdit(row) {
      this.$router.push({ name: 'contract.template_form', query: { id: row.id } })
    },
    handleDel(row) {
      this.$confirm(`确定要删除模板「${row.name}」吗？`, '提示', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.request('delContractTemplate', { id: row.id }).then(res => {
          if (res && res.status === 'success') {
            this.$message.success('删除成功')
            this.loadList()
          }
        })
      }).catch(() => {})
    },
    onPageChange(page) {
      this.currentPage = page
      this.loadList()
    },
  },
  created() {
    this.loadList()
  },
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.pagination-wrap {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/contract/contract-list.vue